/* eslint-disable no-param-reassign, no-multi-assign */
export const timer = (time, mild) => (
  new Promise((resolve, reject) => (
    setTimeout(
      mild ? resolve : () => reject(new Error('TimeoutError')),
      time
    )
  ))
)

export const tracing = (trace) => {
  const table = []
  const start = trace[trace.length - 1][0]
  let previous = start
  trace.slice().reverse().forEach(([time]) => {
    table.push({ type: 'call', time, delta: time - previous, cost: time - start })
    previous = time
  })
  trace.forEach(([, time]) => {
    table.push({ type: 'back', time, delta: time - previous, cost: time - start })
    previous = time
  })
  console.table(table)
}

const packet = 'rpc-response'
export const response = (result, start) => {
  let back = result
  if (typeof back !== 'object' || back.packet !== packet) back = { packet, result }
  const trace = (back.trace || []).concat([[start, Date.now()]])
  return { ...back, trace }
}
response.packet = packet
response.loaded = (value) => {
  value = value || {}
  if (value.packet !== packet) return false
  if (value.result == null) return false
  return true
}

const rpc = (addEventListener, postMessage, channel = 'maisui-rpc') => {
  let seed = 0
  const handle = {}

  addEventListener('message', (event) => {
    const data = event.data || {}
    if (data.channel !== channel) return
    const { requestId } = data
    if ('back' in data) {
      const callback = handle[requestId]
      if (callback) callback(data.back)
    } else if ('call' in data) {
      if (typeof handle.onRequest !== 'function') return
      Promise.resolve(handle.onRequest(data.call))
        .then(back => postMessage({ channel, requestId, back }))
        .catch(error => console.error('RPCRequestReject', error))
    }
  })

  const onResponse = (requestId, start = Date.now()) => (
    new Promise((resolve) => {
      handle[requestId] = resolve
    })
      .then((back) => {
        delete handle[requestId]
        return response(back, start)
      })
  )

  return {
    request: (call, timeout = 400) => {
      const requestId = seed += 1
      const back = Promise.race([
        onResponse(requestId),
        timer(timeout),
      ])
      postMessage({ channel, requestId, call })
      return back
    },
    set onRequest(handleRequest) {
      handle.onRequest = handleRequest
    },
  }
}

export default rpc;
